/// <reference no-default-lib="true"/>
/* eslint-disable */

import { useState } from "react";
import { Button, Card } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import api from "../../services/api";
import LoadingBackdrop from "../../load/loadingBackdrop";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import DescriptionIcon from '@mui/icons-material/Description';

export default function CarimboUser({ admin, setHandleUpdate }) {
  const [carimbo, setCarimbo] = useState("");
  const [open, setOpen] = useState(false);
  const [messageSuccess, setMessageSuccess] = useState("");
  const [messageError, setMessageError] = useState("");
  const user = useSelector((state) => state.account.user);

  const submitEdit = async () => {
    setOpen(true);
    setMessageSuccess("");
    setMessageError("");

    const formData = new FormData();
    formData.append("carimbo", carimbo);
    formData.append("dadosPessoaisId", admin?.dadosPessoais?._id ?? "");
    formData.append("userId", admin?._id ?? "");

    try {
      const res = await api.patch("/admin/edit-carimbo", formData);
      console.log("este é o res 1", res);
      console.log("este é o res", res.data);

      setCarimbo("");
      setOpen(false);
      setMessageSuccess("Salvo com sucesso.");
      setHandleUpdate(res.data);
    } catch (err) {
      setOpen(false);
      setMessageError(err.response?.data?.message || "Erro ao salvar.");
      console.error("Erro na requisição:", err);
    }
  };

  return (
    <>
      {messageSuccess && <MessageSuccess message={messageSuccess} />}
      {messageError && <MessageError message={messageError} />}
      <Card
        style={{
          backgroundColor: "white",
          color: "#333",
          display: "flex",
          alignItems: "center",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "8px",
          width: "100%",
          fontFamily: "sans-serif",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <LoadingBackdrop open={open} text={"A salvar o carimbo."} />

        <div
          style={{ padding: "0 16px", display: "flex", alignItems: "center" }}
        >
          <DescriptionIcon sx={{fontSize: 16}} />
          <p style={{ fontSize: "14px", marginLeft: "8px" }}>
            {carimbo?.name || "Carimbo.png"}
          </p>
        </div>

        <label
          htmlFor={admin?._id + "carimbo"}
          style={{
            backgroundColor: "#85287e",
            color: "white",
            fontSize: "14px",
            padding: "8px 12px",
            borderRadius: "6px",
            cursor: "pointer",
            marginLeft: "auto",
            display: "block",
          }}
        >
          Upload
        </label>

        <input
          style={{ display: "none" }}
          id={admin?._id + "carimbo"}
          type="file"
          name={"carimbo"}
          onChange={(e) => setCarimbo(e.target.files[0])}
        />
      </Card>

      {carimbo && (
        <Button
          variant="outlined"
          color="success"
          onClick={submitEdit}
          size="small"
          style={{ marginTop: "20px" }}
        >
          Salvar
        </Button>
      )}
    </>
  );
}
